import React, { useMemo } from 'react';
import classNames from 'classnames';
import Intl from '@fx-ui/intl';
import { LoginType } from '~/interfaces';
import { isEmpty, isMobileUA, map, size } from '~/utils';
import CollapseLoginItems from './components/collapse-login-items';
import { getAllowSelectedSuites, getOtherLoginItemConfig } from '../../utils/login';

interface OtherLoginsProps {
    items?: LoginType[];
    onLoginTypeChange?: (loginType: LoginType, needCache?: boolean) => void;
}

const OtherLogins: React.FC<OtherLoginsProps> = (props) => {
    const { items = [], onLoginTypeChange } = props;

    const { displayedLoginItems, collapsedLoginItems, showOtherLoginItems } = useMemo(() => {
        const visibleItems = items.filter((item) => getOtherLoginItemConfig(item).visible);
        /**
         * 【其他登录方式】一行最多只能展示得下 5 个 icon
         * 1. 如果其他登录方式不超过 5 个，则依次直接展示即可
         * 2. 如果其他登录方式超过 5 个，则只直接展示前 4 个，剩余的登录方式收起在第 5 个位置的“更多”里
         */
        const displayedItemSize = visibleItems.length <= 5 ? 5 : 4;

        const displayedLoginItems = visibleItems.slice(0, displayedItemSize);
        const collapsedLoginItems = visibleItems.slice(displayedItemSize);

        return {
            displayedLoginItems,
            collapsedLoginItems,
            showOtherLoginItems: !isEmpty(visibleItems)
        };
    }, [items]);

    if (!showOtherLoginItems) {
        return null;
    }

    const handleLoginItemClick = (
        item: LoginType,
        onItemClick?: (callback: () => void) => void,
        needCache = true
    ) => {
        const onLoginItemClick = () => {
            onLoginTypeChange?.(item, needCache);
        };
        if (onItemClick) {
            onItemClick(onLoginItemClick);
        } else {
            onLoginItemClick();
        }
    };

    return (
        <div className={classNames('fx-other-logins', { 'is-mobile': isMobileUA() })}>
            <div className="divider">
                <span>{Intl.get('or')}</span>
            </div>
            <div className="other-login-items">
                {map(displayedLoginItems, (item) => {
                    const config = getOtherLoginItemConfig(item);
                    const suites = getAllowSelectedSuites(item);
                    const needSelectSuite = size(suites) > 1;
                    return (
                        <div
                            key={item}
                            className={classNames('other-login-item', item, config.className)}
                            onClick={() => {
                                if (needSelectSuite) {
                                    handleLoginItemClick(item, undefined, false);
                                } else {
                                    handleLoginItemClick(item, config.onClick);
                                }
                            }}
                        >
                            {config.icon}
                            {config.label && (
                                <span className="other-login-label">{config.label}</span>
                            )}
                        </div>
                    );
                })}
                <CollapseLoginItems
                    className="other-login-item"
                    loginItems={collapsedLoginItems}
                    onLoginItemClick={handleLoginItemClick}
                />
            </div>
        </div>
    );
};

export default OtherLogins;
